import { Box, Theme } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function MinimalLayout() {
  return (
    <Box
      sx={(theme: Theme) => ({
        marginRight: "auto",
        marginLeft: "auto",
        [theme.breakpoints.down("sm")]: {
          maxWidth: 425,
        },
      })}
    >
      <Outlet />
    </Box>
  );
}
